module.exports = __webpack_public_path__ + "img/dragging-image@2x.b8ab887.png";